import { Helmet } from 'react-helmet';
import CompareCompany from 'src/features/CompareCompany';
import MainLayout from 'src/layouts';

const CompareCompanyPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Compare Company</title>
      </Helmet>
      <CompareCompany />
    </MainLayout>
  );
};

export default CompareCompanyPage;
